module.exports = __webpack_public_path__ + "static/img/2018中国CFO最佳财务共享服务奖.53490226.jpg";